import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * Where toasts sit, measured on the county map (docs/agents/county-map-ui.md),
 * 2026-10-21: in the default bottom corner, where MapLibre's scale bar and
 * attribution fill the map's bottom 76px (at 1024px the expanded attribution
 * spans most of the map), so toasts start 96px up, clear of both and of the
 * featured-map banner above them. Every toast uses it. (A top offset that
 * only the old one-time "Kept: …" hop toast used went with it: carried
 * filters show in `CarriedFiltersCard`.)
 */
const TOAST_BOTTOM_OFFSET = 96;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      offset={{ bottom: TOAST_BOTTOM_OFFSET }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
